import React, { useState, useEffect } from "react";
import Card from "components/card";
import InputField from "components/fields/InputField";
import { tokenManager } from 'utils/tokenManager';

const FarmersRegistration = () => {
  const [formData, setFormData] = useState({
    // Personal Data
    farmersName: "",
    physicalAddress: "",
    phoneNumber: "",
    location: "",
    idType: "",
    idNumber: "",
    gender: "",
    age: "",
    educationalLevel: "",
    isCoopMember: "",
    coopName: "",
    coopLocation: "",
    yearsOfMembership: "",
    producerType: "",
    farmLocation: "",
    branch: "",
    associationName: "",
    isLeader: "",
    leaderRole: "",
    // Farm Status
    keepsFarmRecords: "",
    farmRecordsType: "",
    gpsCoordinate: "",
    otherCropsGrown: "",
    // Farm Details (up to 5 farms)
    farms: [
      { location: "", age: "", size: "", yield: "" },
      { location: "", age: "", size: "", yield: "" },
      { location: "", age: "", size: "", yield: "" },
      { location: "", age: "", size: "", yield: "" },
      { location: "", age: "", size: "", yield: "" },
    ],
    // Use of Input
    weedClearingMethod: "",
    majorPestsDiseases: "",
    pestTreatmentMethod: "",
    soilFertilityMaintenance: "",
    fertilizerManureUsed: "",
    lastAgrochemicalDate: "",
    agrochemicalType: "",
    cashewCollectionContainer: "",
    containerOtherUses: "",
    containerCleaningMethod: "",
    cashewDryingLocation: "",
    dryingAreaOtherActivities: "",
    cleansDryingArea: "",
    dryingAreaCleaningMethod: "",
    cashewStorageContainer: "",
    cashewStorageRoom: "",
    transportMeans: "",
    lastChemicalUseDate: "",
    lastChemicalType: "",
    // Infrastructure
    hasProductStore: false,
    hasAgrochemicalStore: false,
    otherInfrastructure: "",
    // Other Needs
    otherNeeds: "",
    // Emergency Contact
    emergencyName: "",
    emergencyRelationship: "",
    emergencyPhone: "",
    // Communication
    preferredCommunication: [],
    otherCommunication: "",
    // Declaration
    declarationDate: "",
    declarationAgreed: false,
    signature: "",
    dataProtectionDate: "",
    dataProtectionAgreed: false,
    inspectedBy: "",
  });


  // Branch associations mapping
  const branchAssociations = {
    "Wenchi": [
      "Wangara",
      "Palongo", 
      "Koase",
      "Wurompo",
      "Akete",
      "Nkonsia"
    ],
    "Techiman": [],
    "Nkoranza": [
      "Fakwasi",
      "Dromankese",
      "Nyame Akwan",
      "Bonte",
      "Senya",
      "Fiema",
      "Tanfiano",
      "Konkrompe",
      "Progressive",
      "Akonkonti Dum",
      "Asempa"
    ],
    "Narelugu": [],
    "Banda": [
      "Ahenkro",
      "Bofie",
      "Kabrono",
      "Makala",
      "Sanwa",
      "Sarbie"
    ],
    "Sampa": [],
    "Nsawkaw": [
      "Njau (Nyameso)",
      "Tanoso",
      "Yabraso",
      "Wiase",
      "Unity",
      "Nsuhunu",
      "Akuapaye",
      "Hani (Eye Adom)",
      "Adwuma Den"
    ]
  };

  const [passportPicture, setPassportPicture] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Special handling for phone number
    if (name === "phoneNumber") {
      // Remove any non-digit characters
      const digitsOnly = value.replace(/\D/g, '');
      
      // Limit to 9 digits
      const formattedValue = digitsOnly.slice(0, 9);
      
      setFormData(prev => ({
        ...prev,
        [name]: formattedValue
      }));
      
      // Validate phone number in real-time
      if (formattedValue.length === 9) {
        const validPrefixes = ['20', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99'];
        const phonePrefix = formattedValue.substring(0, 2);
        
        if (!validPrefixes.includes(phonePrefix)) {
          setPhoneError("Invalid phone number format. Please enter a valid Ghanaian mobile number.");
        } else {
          setPhoneError("");
        }
      } else if (formattedValue.length > 0) {
        setPhoneError("Phone number must be exactly 9 digits");
      } else {
        setPhoneError("");
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleFarmChange = (index, field, value) => {
    const updatedFarms = [...formData.farms];
    updatedFarms[index][field] = value;
    setFormData(prev => ({
      ...prev,
      farms: updatedFarms
    }));
  };

  const handleBranchChange = (e) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      branch: value,
      associationName: "" // Reset association when branch changes
    }));
  };

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "success" });
    }, 3000);
  };

  const handleCheckboxChange = (e) => {
    const { name, value, checked } = e.target;
    
    // Handle infrastructure checkboxes (boolean)
    if (name === "hasProductStore" || name === "hasAgrochemicalStore") {
    setFormData(prev => ({
      ...prev,
      [name]: checked 
      }));
    }
    // Handle preferred communication checkboxes (array)
    else if (name === "preferredCommunication") {
      setFormData(prev => ({
        ...prev,
        preferredCommunication: checked
          ? [...prev.preferredCommunication, value]
          : prev.preferredCommunication.filter(item => item !== value)
      }));
    }
  };

  const handleDeclarationCheckbox = (e) => {
    const { checked } = e.target;
    const currentDate = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format
    
    setFormData(prev => ({
      ...prev,
      declarationAgreed: checked,
      declarationDate: checked ? currentDate : ""
    }));
  };

  const handleDataProtectionCheckbox = (e) => {
    const { checked } = e.target;
    const currentDate = new Date().toISOString().split('T')[0];
    
    setFormData(prev => ({
      ...prev,
      dataProtectionAgreed: checked,
      dataProtectionDate: checked ? currentDate : ""
    }));
  };

  // Get GPS coordinates
  const getGPSLocation = () => {
    setGpsLoading(true);
    
    if (!navigator.geolocation) {
      showToast("GPS is not supported in this browser", "error");
      setGpsLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const gpsCoordinates = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
        setFormData(prev => ({
          ...prev,
          gpsCoordinate: gpsCoordinates
        }));
        showToast("GPS coordinates captured successfully!", "success");
        setGpsLoading(false);
      },
      (error) => {
        console.error('GPS Error:', error);
        let errorMessage = "Unable to get GPS coordinates. ";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage += "Please allow location access.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage += "Location information unavailable.";
            break;
          case error.TIMEOUT:
            errorMessage += "GPS request timed out.";
            break;
          default:
            errorMessage += "Please enter coordinates manually.";
        }
        showToast(errorMessage, "error");
        setGpsLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000
      }
    );
  };

  // Auto-get GPS on component mount
  useEffect(() => {
    getGPSLocation();
  }, []);

  const [showCamera, setShowCamera] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const [error, setError] = useState("");
  const [gpsLoading, setGpsLoading] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const videoRef = React.useRef(null);
  const canvasRef = React.useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPassportPicture(file);
      showToast("Passport picture uploaded successfully!", "success");
    }
  };

  const handleClearPicture = () => {
    setPassportPicture(null);
    showToast("Passport picture cleared", "info");
  };

  const startCamera = () => {
    setError("");
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: 'environment' } })
        .then((stream) => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.play();
          }
        })
        .catch(() => {
          setError("Unable to access camera. Please check your device permissions.");
        });
    } else {
      setError("Camera not supported in this browser.");
    }
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
    }
    setShowCamera(false);
    setError("");
  };

  const capturePhoto = () => {
    const width = 320;
    const height = 240;
    const context = canvasRef.current.getContext("2d");
    context.drawImage(videoRef.current, 0, 0, width, height);
    const dataUrl = canvasRef.current.toDataURL("image/png");
    
    // Convert data URL to File object
    fetch(dataUrl)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], 'passport-photo.jpg', { type: 'image/jpeg' });
        setPassportPicture(file);
        showToast("Photo captured successfully!", "success");
        stopCamera();
      });
  };







  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate phone number format
    if (formData.phoneNumber.length !== 9) {
      showToast("Phone number must be exactly 9 digits", "error");
      return;
    }
    
    // Validate Ghanaian mobile number patterns
    const validPrefixes = ['20', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99'];
    const phonePrefix = formData.phoneNumber.substring(0, 2);
    
    if (!validPrefixes.includes(phonePrefix)) {
      showToast("Invalid phone number format. Please enter a valid Ghanaian mobile number", "error");
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Convert passport picture to base64 if exists
      let passportPictureBase64 = null;
      if (passportPicture) {
        const reader = new FileReader();
        passportPictureBase64 = await new Promise((resolve) => {
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(passportPicture);
        });
      }

      // Prepare the API payload
      const apiPayload = {
        full_name: formData.farmersName,
        physical_address: formData.physicalAddress,
        phone_number: formData.phoneNumber,
        gps_address: formData.gpsCoordinate,
        location: formData.location || null,
        id_type: formData.idType || null,
        id_number: formData.idNumber,
        gender: formData.gender || null,
        age: formData.age ? parseInt(formData.age) : null,
        educational_level: formData.educationalLevel || null,
        is_coop_member: formData.isCoopMember || null,
        coop_name: formData.coopName || null,
        coop_location: formData.coopLocation || null,
        years_of_membership: formData.yearsOfMembership ? parseInt(formData.yearsOfMembership) : null,
        producer_type: formData.producerType || null,
        farm_location: formData.farmLocation || null,
        branch: formData.branch || null,
        association_name: formData.associationName || null,
        leader: formData.isLeader === "YES" ? "Yes" : formData.isLeader === "NO" ? "No" : null,
        role: formData.leaderRole || null,
        keeps_farm_records: formData.keepsFarmRecords || null,
        farm_records_type: formData.farmRecordsType || null,
        gps_coordinate: formData.gpsCoordinate || null,
        other_crops_grown: formData.otherCropsGrown || null,
        farms_data: JSON.stringify(formData.farms),
        weed_clearing_method: formData.weedClearingMethod || null,
        major_pests_diseases: formData.majorPestsDiseases || null,
        pest_treatment_method: formData.pestTreatmentMethod || null,
        soil_fertility_maintenance: formData.soilFertilityMaintenance || null,
        fertilizer_manure_used: formData.fertilizerManureUsed || null,
        last_agrochemical_date: formData.lastAgrochemicalDate || null,
        agrochemical_type: formData.agrochemicalType || null,
        cashew_collection_container: formData.cashewCollectionContainer || null,
        container_other_uses: formData.containerOtherUses || null,
        container_cleaning_method: formData.containerCleaningMethod || null,
        cashew_drying_location: formData.cashewDryingLocation || null,
        drying_area_other_activities: formData.dryingAreaOtherActivities || null,
        cleans_drying_area: formData.cleansDryingArea || null,
        drying_area_cleaning_method: formData.dryingAreaCleaningMethod || null,
        cashew_storage_container: formData.cashewStorageContainer || null,
        cashew_storage_room: formData.cashewStorageRoom || null,
        transport_means: formData.transportMeans || null,
        last_chemical_use_date: formData.lastChemicalUseDate || null,
        last_chemical_type: formData.lastChemicalType || null,
        has_product_store: formData.hasProductStore ? 1 : 0,
        has_agrochemical_store: formData.hasAgrochemicalStore ? 1 : 0,
        other_infrastructure: formData.otherInfrastructure || null,
        other_needs: formData.otherNeeds || null,
        emergency_name: formData.emergencyName || null,
        emergency_relationship: formData.emergencyRelationship || null,
        emergency_phone: formData.emergencyPhone || null,
        preferred_communication: JSON.stringify(formData.preferredCommunication),
        other_communication: formData.otherCommunication || null,
        declaration_date: formData.declarationDate || null,
        declaration_agreed: formData.declarationAgreed ? 1 : 0,
        signature: formData.signature || null,
        data_protection_date: formData.dataProtectionDate || null,
        data_protection_agreed: formData.dataProtectionAgreed ? 1 : 0,
        inspected_by: formData.inspectedBy || null,
        passport_picture_base64: passportPictureBase64
      };

      // Get authorization header
      const authHeader = tokenManager.getAuthHeader();
      if (!authHeader) {
        throw new Error('Authentication token not found. Please login again.');
      }

      // Make API call
      const response = await fetch('https://usibras-web-backend.onrender.com/api/farmers', {
        method: 'POST',
        headers: {
          'Authorization': authHeader,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiPayload)
      });

      const result = await response.json();
      
      console.log("API Response:", result);
      
      // Check if there's a duplicate phone number error
      if (result.error && result.error.includes("already registered")) {
        const errorMessage = result.duplicate_farmer_name 
          ? `${result.error}\n\nThis phone number is already registered to: ${result.duplicate_farmer_name} (ID: ${result.duplicate_farmer_id})`
          : result.error;
        
        setSubmitStatus({
          type: "error",
          message: errorMessage
        });
        showToast(result.error, "error");
        
        // Clear the phone number field and set error state
        setFormData(prev => ({
          ...prev,
          phoneNumber: ""
        }));
        setPhoneError("This phone number is already registered. Please use a different number.");
        return;
      }
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      setSubmitStatus({
        type: "success",
        message: `${result.message} Your farmer code is: ${result.farmer_code || 'N/A'}`
      });
      showToast(`${result.message} Your farmer code is: ${result.farmer_code || 'N/A'}`, "success");
      
      // Reset form
      setFormData({
        farmersName: "",
        physicalAddress: "",
        phoneNumber: "",
        location: "",
        idType: "",
        idNumber: "",
        gender: "",
        age: "",
        educationalLevel: "",
        isCoopMember: "",
        coopName: "",
        coopLocation: "",
        yearsOfMembership: "",
        producerType: "",
        farmLocation: "",
        branch: "",
        associationName: "",
        isLeader: "",
        leaderRole: "",
        keepsFarmRecords: "",
        farmRecordsType: "",
        gpsCoordinate: "",
        otherCropsGrown: "",
        farms: [
          { location: "", age: "", size: "", yield: "" },
          { location: "", age: "", size: "", yield: "" },
          { location: "", age: "", size: "", yield: "" },
          { location: "", age: "", size: "", yield: "" },
          { location: "", age: "", size: "", yield: "" },
        ],
        weedClearingMethod: "",
        majorPestsDiseases: "",
        pestTreatmentMethod: "",
        soilFertilityMaintenance: "",
        fertilizerManureUsed: "",
        lastAgrochemicalDate: "",
        agrochemicalType: "",
        cashewCollectionContainer: "",
        containerOtherUses: "",
        containerCleaningMethod: "",
        cashewDryingLocation: "",
        dryingAreaOtherActivities: "",
        cleansDryingArea: "",
        dryingAreaCleaningMethod: "",
        cashewStorageContainer: "",
        cashewStorageRoom: "",
        transportMeans: "",
        lastChemicalUseDate: "",
        lastChemicalType: "",
        hasProductStore: false,
        hasAgrochemicalStore: false,
        otherInfrastructure: "",
        otherNeeds: "",
        emergencyName: "",
        emergencyRelationship: "",
        emergencyPhone: "",
        preferredCommunication: [],
        otherCommunication: "",
        declarationDate: "",
        declarationAgreed: false,
        signature: "",
        dataProtectionDate: "",
        dataProtectionAgreed: false,
        inspectedBy: "",
      });
      setPassportPicture(null);
    } catch (error) {
      console.error("API Error:", error);
      setSubmitStatus({
        type: "error",
        message: "Failed to submit registration. Please try again."
      });
      showToast("Failed to submit registration. Please try again.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img 
              src="/newlogo-removebg-preview.png" 
              alt="USIBRAS Ghana Limited Logo" 
              className="h-20 w-auto object-contain"
            />
          </div>
          <h2 className="mb-2 text-4xl font-bold text-navy-700 dark:text-white">
            USIBRAS GHANA LTD
          </h2>
          <h3 className="mb-4 text-2xl font-semibold text-navy-600 dark:text-gray-300">
            EU ORGANIC/NOP CERTIFICATION PROGRAMME
          </h3>
          <h4 className="mb-4 text-xl font-semibold text-navy-600 dark:text-gray-300">
            FARMERS REGISTRATION FORM
          </h4>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            Complete the form below to register for the EU Organic/NOP Certification Programme
          </p>
        </div>



        {/* Registration Form */}
        <Card extra="shadow-xl">
          <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-8">
              
              {/* Passport Picture Section - Commented Out
              <div className="border-b border-gray-200 pb-6">
                <h4 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
                  Passport Picture
                </h4>
                
                {showCamera && (
                  <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                    <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md w-full">
                      <div className="text-center mb-4">
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                          Take Photo
                        </h3>
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                          Position your face in the center and click capture
                        </p>
                      </div>
                      
                      {error ? (
                        <div className="text-red-500 mb-4 text-center text-sm">{error}</div>
                      ) : (
                        <>
                          <div className="relative mb-4">
                            <video
                              ref={videoRef}
                              width="320"
                              height="240"
                              className="w-full h-64 object-cover rounded-lg bg-gray-900"
                            />
                            <canvas
                              ref={canvasRef}
                              width="320"
                              height="240"
                              style={{ display: 'none' }}
                            />
                          </div>
                          
                          <div className="flex space-x-3">
                            <button
                              type="button"
                              onClick={capturePhoto}
                              className="flex-1 bg-brand-500 text-white py-2 px-4 rounded-lg hover:bg-brand-600 transition-colors duration-200"
                            >
                              📸 Capture
                            </button>
                            <button
                              type="button"
                              onClick={stopCamera}
                              className="flex-1 bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600 transition-colors duration-200"
                            >
                              ❌ Cancel
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                
                <div className="flex items-center space-x-4">
                  <div className="w-32 h-40 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50">
                    {passportPicture ? (
                      <img 
                        src={URL.createObjectURL(passportPicture)} 
                        alt="Passport" 
                        className="w-full h-full object-cover rounded-lg"
                      />
                    ) : (
                      <div className="text-center text-gray-500">
                        <svg className="w-8 h-8 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <span className="text-xs">Upload Photo</span>
                      </div>
                    )}
                  </div>
                  <div className="flex-1">
                    <div className="flex space-x-2 mb-2">
                      <button
                        type="button"
                        onClick={() => {
                          setShowCamera(true);
                          setTimeout(() => startCamera(), 200);
                        }}
                        className="flex-1 bg-brand-500 text-white py-2 px-3 rounded-lg text-sm hover:bg-brand-600 transition-colors duration-200 flex items-center justify-center space-x-1"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span>Take Photo</span>
                      </button>
                      <div className="relative">
                        <input
                          type="file"
                          name="passportPicture"
                          accept="image/*"
                          onChange={handleFileChange}
                          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        />
                        <button
                          type="button"
                          className="flex-1 bg-gray-500 text-white py-2 px-3 rounded-lg text-sm hover:bg-gray-600 transition-colors duration-200 flex items-center justify-center space-x-1"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                          <span>Upload</span>
                        </button>
                      </div>
                    </div>
                    <p className="text-xs text-gray-500 mb-2">
                      Take a photo with your camera or upload an existing image
                    </p>
                    {passportPicture && (
                      <button
                        type="button"
                        onClick={handleClearPicture}
                        className="px-3 py-1 text-xs bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors duration-200"
                      >
                        Clear Photo
                      </button>
                    )}
                  </div>
                </div>
              </div>
              */}

              {/* 1. Personal Data */}
              <div>
                <h4 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
                  PERSONAL DATA
                </h4>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <InputField
                    label="Farmer's Name"
                    id="farmersName"
                      type="text"
                    name="farmersName"
                    value={formData.farmersName}
                      onChange={handleInputChange}
                      required
                  />
                  <InputField
                    label="Physical Address"
                    id="physicalAddress"
                    type="text"
                    name="physicalAddress"
                    value={formData.physicalAddress}
                    onChange={handleInputChange}
                    required
                    />
                  </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                  <div>
                    <label htmlFor="phoneNumber" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      Phone Number
                    </label>
                                         <input
                       type="tel"
                       id="phoneNumber"
                       name="phoneNumber"
                       value={formData.phoneNumber}
                       onChange={handleInputChange}
                       required
                       maxLength={9}
                       pattern="[0-9]{9}"
                       placeholder="e.g., 245678901"
                       className={`mt-2 block w-full rounded-md border px-3 py-2 text-sm shadow-sm outline-none placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400 ${
                         phoneError 
                           ? 'border-red-500 text-red-700 dark:border-red-500 dark:text-red-400' 
                           : 'border-gray-300 text-gray-700 dark:border-gray-600'
                       }`}
                     />
                                         <p className="mt-1 text-xs text-gray-500">
                       Enter 9 digits only (e.g., 245678901). Do not include (0), +233, or 233.
                     </p>
                     {phoneError && (
                       <p className="mt-1 text-xs text-red-500">
                         {phoneError}
                       </p>
                     )}
                  </div>
                  <InputField
                    label="ID Number (National ID/Voters ID)"
                    id="idNumber"
                    type="text"
                    name="idNumber"
                    value={formData.idNumber}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                  <div>
                    <label htmlFor="gender" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      Gender
                    </label>
                    <select
                      id="gender"
                      name="gender"
                      value={formData.gender}
                        onChange={handleInputChange}
                        required
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                    </div>
                  <InputField
                    label="Age"
                    id="age"
                    type="number"
                    name="age"
                    value={formData.age}
                    onChange={handleInputChange}
                    required
                  />
                  </div>

                <div className="mt-4">
                  <label className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                    Educational Level
                    </label>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    {["Primary", "Secondary", "Tertiary", "Post tertiary"].map((level) => (
                      <label key={level} className="flex items-center space-x-2 cursor-pointer">
                    <input
                          type="radio"
                          name="educationalLevel"
                          value={level}
                          checked={formData.educationalLevel === level}
                      onChange={handleInputChange}
                      required
                          className="text-brand-500 focus:ring-brand-500"
                    />
                        <span className="text-sm text-gray-700 dark:text-gray-300">{level}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="mt-4">
                  <label className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                    Are you a member of a Co-op?
                  </label>
                  <div className="flex gap-4">
                    <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                        name="isCoopMember"
                        value="YES"
                        checked={formData.isCoopMember === "YES"}
                          onChange={handleInputChange}
                          required
                          className="text-brand-500 focus:ring-brand-500"
                        />
                      <span className="text-sm text-gray-700 dark:text-gray-300">YES</span>
                      </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="isCoopMember"
                        value="NO"
                        checked={formData.isCoopMember === "NO"}
                        onChange={handleInputChange}
                        required
                        className="text-brand-500 focus:ring-brand-500"
                      />
                      <span className="text-sm text-gray-700 dark:text-gray-300">NO</span>
                    </label>
                  </div>
                </div>

                {formData.isCoopMember === "YES" && (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                  <InputField
                      label="Co-op Name"
                      id="coopName"
                    type="text"
                      name="coopName"
                      value={formData.coopName}
                    onChange={handleInputChange}
                    />
                    <InputField
                      label="Location"
                      id="coopLocation"
                      type="text"
                      name="coopLocation"
                      value={formData.coopLocation}
                      onChange={handleInputChange}
                    />
                    <InputField
                      label="No of Years of Membership"
                      id="yearsOfMembership"
                      type="number"
                      name="yearsOfMembership"
                      value={formData.yearsOfMembership}
                      onChange={handleInputChange}
                  />
                </div>
                )}

                <div className="mt-4">
                  <label htmlFor="producerType" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                    Producer Type
                  </label>
                  <select
                    id="producerType"
                    name="producerType"
                    value={formData.producerType}
                    onChange={handleInputChange}
                    required
                    className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                  >
                    <option value="">Select Producer Type</option>
                    <option value="Landowner">Landowner</option>
                    <option value="Sharecropper">Sharecropper</option>
                    <option value="Caretaker">Caretaker</option>
                  </select>
              </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div>
                  <label htmlFor="branch" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      Branch Name
                  </label>
                  <select
                    id="branch"
                    name="branch"
                    value={formData.branch}
                    onChange={handleBranchChange}
                    required
                    className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                  >
                    <option value="">Select a branch</option>
                    <option value="Techiman">Techiman</option>
                    <option value="Nkoranza">Nkoranza</option>
                    <option value="Narelugu">Narelugu</option>
                    <option value="Banda">Banda</option>
                    <option value="Sampa">Sampa</option>
                    <option value="Wenchi">Wenchi</option>
                    <option value="Nsawkaw">Nsawkaw</option>
                  </select>
                </div>

                  <div>
                    <label htmlFor="associationName" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      Association Name
                    </label>
                    {formData.branch && branchAssociations[formData.branch] && branchAssociations[formData.branch].length > 0 ? (
                      <select
                        id="associationName"
                        name="associationName"
                        value={formData.associationName}
                        onChange={handleInputChange}
                        required
                        className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                      >
                        <option value="">Select an association</option>
                        {branchAssociations[formData.branch].map((association) => (
                          <option key={association} value={association}>
                            {association}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        id="associationName"
                        name="associationName"
                        value={formData.associationName}
                        onChange={handleInputChange}
                        required
                        className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                        placeholder="Enter association name"
                      />
                    )}
                  </div>
                </div>

                <div className="mt-4">
                  <label className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                    Leader
                  </label>
                  <div className="flex gap-4">
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="isLeader"
                        value="YES"
                        checked={formData.isLeader === "YES"}
                        onChange={handleInputChange}
                        required
                        className="text-brand-500 focus:ring-brand-500"
                      />
                      <span className="text-sm text-gray-700 dark:text-gray-300">YES</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="isLeader"
                        value="NO"
                        checked={formData.isLeader === "NO"}
                        onChange={handleInputChange}
                        required
                        className="text-brand-500 focus:ring-brand-500"
                      />
                      <span className="text-sm text-gray-700 dark:text-gray-300">NO</span>
                    </label>
                </div>
              </div>

                {formData.isLeader === "YES" && (
                  <div className="mt-4">
                    <InputField
                      label="Role"
                      id="leaderRole"
                      type="text"
                      name="leaderRole"
                      value={formData.leaderRole}
                      onChange={handleInputChange}
                      placeholder="Enter leadership role"
                    />
                  </div>
                )}
              </div>

              {/* 2. Farm Status */}
              <div>
                <h4 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
                  FARM STATUS
                </h4>
                
                <div className="mt-4">
                  <label className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                    Do you keep farm Records?
                  </label>
                  <div className="flex gap-4">
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="keepsFarmRecords"
                        value="YES"
                        checked={formData.keepsFarmRecords === "YES"}
                    onChange={handleInputChange}
                    required
                        className="text-brand-500 focus:ring-brand-500"
                      />
                      <span className="text-sm text-gray-700 dark:text-gray-300">YES</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="keepsFarmRecords"
                        value="NO"
                        checked={formData.keepsFarmRecords === "NO"}
                    onChange={handleInputChange}
                    required
                        className="text-brand-500 focus:ring-brand-500"
                  />
                      <span className="text-sm text-gray-700 dark:text-gray-300">NO</span>
                    </label>
                  </div>
                </div>

                {formData.keepsFarmRecords === "YES" && (
                <div className="mt-4">
                  <InputField
                      label="Type of Records"
                      id="farmRecordsType"
                      type="text"
                      name="farmRecordsType"
                      value={formData.farmRecordsType}
                      onChange={handleInputChange}
                      placeholder="e.g., Digital, Paper, etc."
                    />
                  </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                  <div>
                    <label htmlFor="gpsCoordinate" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      GPS coordinate of largest organic cashew farm
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        id="gpsCoordinate"
                        name="gpsCoordinate"
                        value={formData.gpsCoordinate}
                    onChange={handleInputChange}
                    required
                        readOnly
                        className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                        placeholder={gpsLoading ? "Getting GPS coordinates..." : "GPS coordinates will appear here"}
                      />
                      <button
                        type="button"
                        onClick={getGPSLocation}
                        disabled={gpsLoading}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 text-gray-500 hover:text-gray-700 disabled:opacity-50"
                        title="Refresh GPS coordinates"
                      >
                        {gpsLoading ? (
                          <svg className="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                          </svg>
                        ) : (
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                          </svg>
                        )}
                      </button>
                </div>
                    <p className="mt-1 text-xs text-gray-500">
                      GPS coordinates are automatically detected from your device location
                    </p>
                  </div>
                  <InputField
                    label="Other Crops grown"
                    id="otherCropsGrown"
                    type="text"
                    name="otherCropsGrown"
                    value={formData.otherCropsGrown}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter crop names"
                  />
              </div>

                {/* Cashew Farm Status Table */}
                <div className="mt-6">
                  <h5 className="mb-3 text-lg font-semibold text-navy-700 dark:text-white">
                    Cashew Farm Status
                  </h5>
                  <div className="overflow-x-auto">
                    <table className="min-w-full border border-gray-300 dark:border-gray-600">
                      <thead className="bg-gray-100 dark:bg-gray-800">
                        <tr>
                          <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-left text-sm font-semibold text-navy-700 dark:text-white">Farm</th>
                          <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-left text-sm font-semibold text-navy-700 dark:text-white">Location</th>
                          <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-left text-sm font-semibold text-navy-700 dark:text-white">Age (years)</th>
                          <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-left text-sm font-semibold text-navy-700 dark:text-white">Size (acres)</th>
                          <th className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-left text-sm font-semibold text-navy-700 dark:text-white">Yield 2023/24 season (kg)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.farms.map((farm, index) => (
                          <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                            <td className="border border-gray-300 dark:border-gray-600 px-4 py-2 text-sm text-gray-700 dark:text-gray-300">
                              FARM {index + 1}
                            </td>
                            <td className="border border-gray-300 dark:border-gray-600 px-2 py-2">
                              <input
                                type="text"
                                value={farm.location}
                                onChange={(e) => handleFarmChange(index, 'location', e.target.value)}
                                className="w-full px-2 py-1 text-sm border-0 bg-transparent focus:ring-1 focus:ring-brand-500 rounded text-gray-700 dark:text-white"
                                placeholder="Location"
                              />
                            </td>
                            <td className="border border-gray-300 dark:border-gray-600 px-2 py-2">
                              <input
                                type="number"
                                value={farm.age}
                                onChange={(e) => handleFarmChange(index, 'age', e.target.value)}
                                className="w-full px-2 py-1 text-sm border-0 bg-transparent focus:ring-1 focus:ring-brand-500 rounded text-gray-700 dark:text-white"
                                placeholder="Age"
                              />
                            </td>
                            <td className="border border-gray-300 dark:border-gray-600 px-2 py-2">
                              <input
                                type="number"
                                step="0.01"
                                value={farm.size}
                                onChange={(e) => handleFarmChange(index, 'size', e.target.value)}
                                className="w-full px-2 py-1 text-sm border-0 bg-transparent focus:ring-1 focus:ring-brand-500 rounded text-gray-700 dark:text-white"
                                placeholder="Size"
                              />
                            </td>
                            <td className="border border-gray-300 dark:border-gray-600 px-2 py-2">
                              <input
                                type="number"
                                step="0.01"
                                value={farm.yield}
                                onChange={(e) => handleFarmChange(index, 'yield', e.target.value)}
                                className="w-full px-2 py-1 text-sm border-0 bg-transparent focus:ring-1 focus:ring-brand-500 rounded text-gray-700 dark:text-white"
                                placeholder="Yield"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <p className="mt-2 text-xs text-gray-500">
                    Fill in details for all farms you own. Leave rows empty if you have less than 5 farms.
                  </p>
                </div>
              </div>

              {/* 3. USE OF INPUT */}
              <div>
                <h4 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
                  USE OF INPUT
                </h4>
                
                <div className="space-y-4">
                  <div>
                    <label htmlFor="weedClearingMethod" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      1.0 How do you clear weeds from the cashew farm?
                    </label>
                    <textarea
                      id="weedClearingMethod"
                      name="weedClearingMethod"
                      value={formData.weedClearingMethod}
                      onChange={handleInputChange}
                      required
                      rows={2}
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="majorPestsDiseases" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      1.1 What major pest/diseases do you find on the farm?
                    </label>
                    <textarea
                      id="majorPestsDiseases"
                      name="majorPestsDiseases"
                      value={formData.majorPestsDiseases}
                      onChange={handleInputChange}
                      required
                      rows={2}
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="pestTreatmentMethod" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      1.1a How do you treat such pest and diseases?
                    </label>
                    <textarea
                      id="pestTreatmentMethod"
                      name="pestTreatmentMethod"
                      value={formData.pestTreatmentMethod}
                      onChange={handleInputChange}
                      required
                      rows={2}
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="soilFertilityMaintenance" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      1.1b How do you maintain soil fertility?
                    </label>
                    <textarea
                      id="soilFertilityMaintenance"
                      name="soilFertilityMaintenance"
                      value={formData.soilFertilityMaintenance}
                      onChange={handleInputChange}
                      required
                      rows={2}
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="fertilizerManureUsed" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      1.1c What Fertilizer/Manure do you use?
                    </label>
                    <input
                      type="text"
                      id="fertilizerManureUsed"
                      name="fertilizerManureUsed"
                      value={formData.fertilizerManureUsed}
                      onChange={handleInputChange}
                      required
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="lastAgrochemicalDate" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                        1.1d Last date of use of agrochemicals
                      </label>
                      <input
                        type="date"
                        id="lastAgrochemicalDate"
                        name="lastAgrochemicalDate"
                        value={formData.lastAgrochemicalDate}
                        onChange={handleInputChange}
                        className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                      />
                    </div>
                    <div>
                      <label htmlFor="agrochemicalType" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                        Type
                      </label>
                      <input
                        type="text"
                        id="agrochemicalType"
                        name="agrochemicalType"
                        value={formData.agrochemicalType}
                        onChange={handleInputChange}
                        placeholder="Type of agrochemical"
                        className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="cashewCollectionContainer" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      2.0 What container do you use to collect the cashew?
                    </label>
                    <input
                      type="text"
                      id="cashewCollectionContainer"
                      name="cashewCollectionContainer"
                      value={formData.cashewCollectionContainer}
                      onChange={handleInputChange}
                      required
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="containerOtherUses" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      2.1 What other use do you put the above container to?
                    </label>
                    <textarea
                      id="containerOtherUses"
                      name="containerOtherUses"
                      value={formData.containerOtherUses}
                      onChange={handleInputChange}
                      required
                      rows={2}
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="containerCleaningMethod" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      2.1a How do you clean this container?
                    </label>
                    <input
                      type="text"
                      id="containerCleaningMethod"
                      name="containerCleaningMethod"
                      value={formData.containerCleaningMethod}
                      onChange={handleInputChange}
                      required
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="cashewDryingLocation" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      3.0 Where do you dry the cashew?
                    </label>
                    <input
                      type="text"
                      id="cashewDryingLocation"
                      name="cashewDryingLocation"
                      value={formData.cashewDryingLocation}
                      onChange={handleInputChange}
                      required
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="dryingAreaOtherActivities" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      3.1 What other crop or activity is undertaken on the drying area?
                    </label>
                    <textarea
                      id="dryingAreaOtherActivities"
                      name="dryingAreaOtherActivities"
                      value={formData.dryingAreaOtherActivities}
                      onChange={handleInputChange}
                      required
                      rows={2}
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                  <label className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      3.1a Do you clean the drying area?
                  </label>
                    <div className="flex gap-4 mt-2">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="cleansDryingArea"
                          value="YES"
                          checked={formData.cleansDryingArea === "YES"}
                          onChange={handleInputChange}
                          required
                          className="text-brand-500 focus:ring-brand-500"
                        />
                        <span className="text-sm text-gray-700 dark:text-gray-300">YES</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="cleansDryingArea"
                          value="NO"
                          checked={formData.cleansDryingArea === "NO"}
                          onChange={handleInputChange}
                          required
                          className="text-brand-500 focus:ring-brand-500"
                        />
                        <span className="text-sm text-gray-700 dark:text-gray-300">NO</span>
                      </label>
                    </div>
                    {formData.cleansDryingArea === "YES" && (
                      <div className="mt-3">
                        <label htmlFor="dryingAreaCleaningMethod" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                          With what?
                        </label>
                        <input
                          type="text"
                          id="dryingAreaCleaningMethod"
                          name="dryingAreaCleaningMethod"
                          value={formData.dryingAreaCleaningMethod}
                          onChange={handleInputChange}
                          placeholder="Cleaning materials/methods"
                          className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                        />
                      </div>
                    )}
                  </div>
                  
                  <div>
                    <label htmlFor="cashewStorageContainer" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      4.0 In what container do you store the cashew?
                    </label>
                    <input
                      type="text"
                      id="cashewStorageContainer"
                      name="cashewStorageContainer"
                      value={formData.cashewStorageContainer}
                      onChange={handleInputChange}
                      required
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div>
                    <label htmlFor="cashewStorageRoom" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      4.1 Where (room) do you store the cashew when dried?
                    </label>
                    <input
                      type="text"
                      id="cashewStorageRoom"
                      name="cashewStorageRoom"
                      value={formData.cashewStorageRoom}
                      onChange={handleInputChange}
                      required
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                </div>

                  <div>
                    <label htmlFor="transportMeans" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      5.0 What means do you use to transport the dried cashew to the buying center?
                    </label>
                    <input
                    type="text"
                      id="transportMeans"
                      name="transportMeans"
                      value={formData.transportMeans}
                    onChange={handleInputChange}
                      required
                      className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="lastChemicalUseDate" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                        Last date of chemical use
                      </label>
                      <input
                        type="date"
                        id="lastChemicalUseDate"
                        name="lastChemicalUseDate"
                        value={formData.lastChemicalUseDate}
                        onChange={handleInputChange}
                        className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                      />
                    </div>
                    <div>
                      <label htmlFor="lastChemicalType" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                        Which type?
                      </label>
                      <input
                        type="text"
                        id="lastChemicalType"
                        name="lastChemicalType"
                        value={formData.lastChemicalType}
                        onChange={handleInputChange}
                        placeholder="Type of chemical"
                        className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                      Infrastructure owned (tick where applicable)
                    </label>
                    <div className="space-y-2 mt-2">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          name="hasProductStore"
                          checked={formData.hasProductStore}
                          onChange={handleCheckboxChange}
                          className="w-4 h-4 text-brand-500 focus:ring-brand-500"
                        />
                        <span className="text-sm text-gray-700 dark:text-gray-300">Product Store</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          name="hasAgrochemicalStore"
                          checked={formData.hasAgrochemicalStore}
                          onChange={handleCheckboxChange}
                          className="w-4 h-4 text-brand-500 focus:ring-brand-500"
                        />
                        <span className="text-sm text-gray-700 dark:text-gray-300">Agrochemical Store</span>
                      </label>
                      <div className="mt-2">
                        <label htmlFor="otherInfrastructure" className="text-sm text-gray-700 dark:text-gray-300 mb-1 block">
                          Others:
                        </label>
                        <input
                          type="text"
                          id="otherInfrastructure"
                          name="otherInfrastructure"
                          value={formData.otherInfrastructure}
                          onChange={handleInputChange}
                          placeholder="Specify other infrastructure"
                          className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 4. Other Needs */}
              <div>
                <h4 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
                  Any other needs deemed necessary for successful organic integrity by farmer
                </h4>
                
                <div>
                  <label htmlFor="otherNeeds" className="text-sm text-navy-700 dark:text-white ml-3 font-bold mb-2 block">
                    (recommended by F.O.)
                  </label>
                  <textarea
                    id="otherNeeds"
                    name="otherNeeds"
                    value={formData.otherNeeds}
                    onChange={handleInputChange}
                    rows={4}
                    className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm outline-none text-gray-700 placeholder:text-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                    placeholder="Enter any other needs or recommendations..."
                  />
                </div>
              </div>

              {/* 5. Declaration */}
              <div>
                <h4 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
                  Declaration
                </h4>
                
                <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg mb-4">
                  <p className="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
                    I hereby confirm my intention to be a part of the EU Organic/NOP Certification programme. 
                    I agree to cooperate fully with Certification Requirements towards ensuring that the 
                    EU/NOP Organic Standard Requirements are fully met.
                  </p>
                </div>

                <div className="mb-4">
                  <label className="flex items-center space-x-3 cursor-pointer">
                    <input
                      type="checkbox"
                      name="declarationAgreed"
                      checked={formData.declarationAgreed}
                      onChange={handleDeclarationCheckbox}
                      className="w-4 h-4 text-brand-500 bg-gray-100 border-gray-300 rounded focus:ring-brand-500 focus:ring-2"
                      required
                    />
                    <span className="text-sm text-gray-700 dark:text-gray-300">
                      I agree to the above declaration
                    </span>
                  </label>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <InputField
                    label="Date"
                    id="declarationDate"
                    type="date"
                    name="declarationDate"
                    value={formData.declarationDate}
                    onChange={handleInputChange}
                    required
                    disabled={!formData.declarationAgreed}
                  />
                </div>
              </div>

              {/* 6. Inspector Information */}
              <div>
                <h4 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
                  Inspector Information (For Official Use Only)
                </h4>
                
                <div>
                  <InputField
                    label="Inspected by"
                    id="inspectedBy"
                    type="text"
                    name="inspectedBy"
                    value={formData.inspectedBy}
                    onChange={handleInputChange}
                    placeholder="Inspector's name and signature"
                  />
                </div>
              </div>



              {/* Submit Button */}
              <div className="pt-6 border-t border-gray-200">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full flex items-center justify-center h-12 rounded-xl bg-brand-500 text-white font-medium hover:bg-brand-600 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed relative overflow-hidden"
                >
                  {isSubmitting ? (
                    <>
                      <div className="flex items-center space-x-2">
                        <div className="relative">
                          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        </div>
                        <span>Processing Registration...</span>
                      </div>
                      {/* Animated background */}
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse"></div>
                    </>
                  ) : (
                    "Submit Registration"
                  )}
                </button>
                
                {/* Modern Loading Overlay */}
                {isSubmitting && (
                  <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-50 flex items-center justify-center">
                    <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-2xl max-w-sm w-full mx-4">
                      <div className="text-center">
                        {/* Loading Text */}
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                          Submitting Registration
                        </h3>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
                          Please wait while we process your information...
                        </p>
                        
                        {/* Progress Bar */}
                        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 mb-4">
                          <div className="bg-gradient-to-r from-brand-500 to-brand-600 h-2 rounded-full animate-pulse" style={{width: '60%'}}></div>
                        </div>
                        
                        {/* Loading Dots */}
                        <div className="flex justify-center space-x-1">
                          <div className="w-2 h-2 bg-brand-500 rounded-full animate-bounce"></div>
                          <div className="w-2 h-2 bg-brand-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                          <div className="w-2 h-2 bg-brand-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
                <p className="mt-4 text-center text-sm text-gray-600 dark:text-gray-400">
                  Please ensure all required fields are completed before submitting.
                </p>
              </div>
            </form>
          </div>
        </Card>

        {/* Toast Notification */}
        {toast.show && (
          <div className={`fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg max-w-sm transition-all duration-300 ${
            toast.type === "success" 
              ? "bg-green-500 text-white" 
              : toast.type === "error"
              ? "bg-red-500 text-white"
              : toast.type === "warning"
              ? "bg-yellow-500 text-white"
              : "bg-blue-500 text-white"
          }`}>
            <div className="flex items-center space-x-2">
              <div className="flex-shrink-0">
                {toast.type === "success" && (
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                )}
                {toast.type === "error" && (
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                )}
                {toast.type === "warning" && (
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                )}
                {toast.type === "info" && (
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium">{toast.message}</p>
              </div>
              <button
                onClick={() => setToast({ show: false, message: "", type: "success" })}
                className="flex-shrink-0 ml-2 text-white hover:text-gray-200"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default FarmersRegistration; 